module.exports = __webpack_public_path__ + "assets/b138f203cac43f06d50a298b39b56f80.jpg";